import React from 'react';
import classes from './Loading.css';

const Loading = props => {
  const { size = 'small' } = props;

  return (
    <div className={classes[`progress-${size}`]}>
      <svg
        viewBox="0 0 24 24"
        width={classes[size].width}
        height={classes[size].height}
      >
        <g
          className="nc-icon-wrapper"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          fill="#2d9f86"
          stroke="#2d9f86"
        >
          <g className="nc-loop_circle-04-24">
            <path
              data-cap="butt"
              fill="none"
              stroke="#2d9f86"
              strokeMiterlimit="10"
              d="M1.9596902,16.5002346 C1.3430252,15.1265316,1,13.6033249,1,12C1,5.9248676,5.9248676,1,12,1s11,4.9248676,11,11s-4.9248676,11-11,11 c-2.6506577,0-5.0823407-0.937542-6.9815297-2.4991035"
              transform="rotate(87.91350001096725 12 12)"
            />
          </g>
        </g>
      </svg>
    </div>
  );
};

export default Loading;



// WEBPACK FOOTER //
// ./src/views/components/Loading/Loading.jsx